import $ from 'jquery';

class DeleteUser {

    constructor() {

        this.$el = $('.js-delete-user');

        if (!this.$el.length) {
            return;
        }

        this.$btn = this.$el.find('.js-btn');
        this.userId = this.$el.data('userId');

        this.$el.on('click', () => this.delete());
    }

    displayError(message) {
        this.$el.html(message);
    }

    /**
     * Deletes an alert
     */
    async delete() {

        if (!this.userId) {
            throw new Error('userId undefined');
        }

        try {

            const response = await fetch('/api/users', {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'same-origin',
                body: JSON.stringify({
                    userId: String(this.userId),
                }),
            });

            if (response.ok) {
                window.location.reload();
            } else {
                this.displayError('There was an error while sending your request. Please try again later.');
            }

        } catch (err) {
            this.displayError('There was an error while sending your request. Please try again later.');
        }
    }
}

export default new DeleteUser();
